import { conditionForFilterElementsByManyKeys } from './search';

export const getLocalSearchDataWithSubRows = <T extends { uid: string; subRows?: T[] | null | undefined }>(
  localSearch: string,
  allData: T[],
  localSearchKeys: (keyof T)[]
): T[] => {
  const filteredDataWithSubRows = allData.map((parent) => {
    if (!parent.subRows) {
      return parent;
    }
    const filteredSubRows = getLocalSearchDataWithSubRows(localSearch, parent.subRows, localSearchKeys);
    return { ...parent, subRows: filteredSubRows };
  });
  return filteredDataWithSubRows.filter((row) => {
    if (row.subRows && row.subRows.length > 0) return true;
    return conditionForFilterElementsByManyKeys(localSearch, row, localSearchKeys);
  });
};
